import React, { useMemo } from 'react';
import { useUserContext } from '../../common/user-context';
import { PRODUCT_SEARCH_DIALOG_KEY, getRecentSearches } from '@atlassian/search-common';
import { useProductContext } from '../product-router';
import { DefaultIcon } from './icons/default-icon';
import { sha256Hash } from '../../common/analytics/utils';
export var MAX_RECENT_SEARCHES_RETURNED = 50; // It can be different from the number of records in local storage

export var useRecentSearches = function useRecentSearches(_ref) {
  var _ref$Icon = _ref.Icon,
    Icon = _ref$Icon === void 0 ? /*#__PURE__*/React.createElement(DefaultIcon, null) : _ref$Icon,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? MAX_RECENT_SEARCHES_RETURNED : _ref$limit;
  var _useUserContext = useUserContext(),
    user = _useUserContext.user;
  var _useProductContext = useProductContext(),
    getActiveProduct = _useProductContext.getActiveProduct;
  var recentSearchItems = useMemo(function () {
    var product = getActiveProduct();
    if (!product || !user.id) {
      return [];
    }
    var recentSearches = getRecentSearches(user.id, product.id, PRODUCT_SEARCH_DIALOG_KEY);
    var searchResults = recentSearches.slice(0, limit).map(function (value) {
      return {
        id: sha256Hash(value),
        title: value,
        icon: Icon
      };
    });
    return searchResults;
  }, [getActiveProduct, user.id, Icon, limit]);
  return recentSearchItems;
};